// theme.js
export const blueTheme = {
  body: "#EDF9FE",
  text: "#001C55",
  highlight: "#A6E1FA",
  dark: "#00072D",
  secondaryText: "#7F8DAA",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#0E6BA877",
};

export const myTheme = {
  body: "#eeeeee",
  text: "#8b8c89",
  highlight: "#bbbbbb",
  dark: "#031E26",
  secondaryText: "#8b8c89",
  imageHighlight: "#07beb8",
  compImgHighlight: "#E6E6E6",
  headerColor: "#07beb877",
};

export const chosenTheme = myTheme;


